import {
	Checkbox,
	IconButton,
	makeStyles,
	Tooltip
} from "@material-ui/core";
import BorderColorIcon from "@material-ui/icons/BorderColor";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import DeleteIcon from "@material-ui/icons/Delete";
import VisibilityIcon from "@material-ui/icons/Visibility";
import PropTypes from "prop-types";
import React from "react";
import { permissionIcons } from "../../../../constants/permissions";
import { validAscents } from "../../../../constants/propTypesValidation";
import { formatDateTime } from "../../../../utils/other";
import TableCell from "./TableCell";
import TableRow from "./TableRow";



const useStyle = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(0, 1, 0, 1.5),
		height: 33,
		fontWeight: 600,
		...theme.typography.body2,
	},
	head: {
		color: theme.palette.ascents.systemWhite,
		padding: theme.spacing(0, 1, 0, 1.5),
		height: 33,
		fontWeight: 600,
		...theme.typography.body2,
		"&:hover": {
			color: theme.palette.ascents.systemWhite,
		},
	},
	buttons: {
		padding: theme.spacing(0.75),
		"& .MuiSvgIcon-root": {
			fontSize: "16px",
			color: theme.palette.ascents.textLightDark,
			"&:hover": {
				color: theme.palette.ascents.primary,
			},
		},
	},
	action: {
		// width: "7rem",
	},
	customAction: {
		width: "12rem",
	}
}));

const TableData = ({
	align,
	className,
	ascent = "systemWhite",
	onClickCheckbox,
	hideSelect,
	handleSwitchToggle = () => { },
	handleCheck = () => { },
	isSelected = () => { },
	hideActionCol,
	page,
	rowsPerPage,
	crud = {},
	tableData = [],
	headCells = {},
	idKeyInHeadCell,
	hasFormField = false,
	hideCrudButtons = false,
	formConstant = {},
	CustomAction,
	ActiveComponent = () => null,
	InActiveComponent = () => null,
	onClickAction = () => { },
	onReadData = () => { },
	onEditData = () => { },
	onDeleteData = () => { },
	...props
}) => {
	const classes = useStyle({
		ascent,
	});

	const [crudActions, setCrudActions] = React.useState({})


	// const crudActions = {
	// onRead: (eachData) => () => {
	// 	onReadData(eachData);
	// },
	// 	onDelete: (eachData) => () => {
	// 		onDeleteData(eachData);
	// 	},
	// 	onUpdate: (eachData) => () => {
	// 		onEditData(eachData);
	// 	},
	// };

	const viewIcon = (eachData) => (
		<IconButton
			onClick={crudActions && crudActions.onRead(eachData)}
			disabled={crud && crud.canRead < 1}
			className={classes.buttons}
		>
			<VisibilityIcon fontSize={"small"} />
		</IconButton>)

	const editIcon = (eachData) => (
		<IconButton
			onClick={crudActions && crudActions.onUpdate(eachData)}
			disabled={!crud.canUpdate}
			className={classes.buttons}
		>
			<BorderColorIcon fontSize={"small"} />
		</IconButton>

	)
	const deleteIcon = (eachData) => (
		<IconButton
			onClick={crudActions && crudActions.onDelete(eachData)}
			disabled={!crud.canDelete}
			className={classes.buttons}
		>
			<DeleteIcon fontSize={"small"} />
		</IconButton>
	)

	// eachHeadcell's Obj.id is JSON key of data
	const Cell = (eachData) => (each, i) => {
		var headCell = headCells[each];

		/* 
				eachData[orgCode] === null {
					headCell.InActiveComponent()
				}
			*/

		var dataValue;

		if (headCell.labelJsonKey) {
			dataValue = eachData[headCell.labelJsonKey];
		} else {
			if (!headCell.hidden) {
				if (eachData[headCell.id] === 0 || eachData[headCell.id] === '0') {
					dataValue = 0
				}
				else {
					dataValue = eachData[headCell.id] || "----";
				}
			}
		}

		return (
			<TableCell style={headCell.hidden ? { display: "none" } : undefined} color="textLight" align={align} key={(headCell && headCell.id) || i}>
				{
					headCell.showComponent ? (
						dataValue ? (
							<ActiveComponent
								eachData={eachData}
								jsonKey={headCell.id}
							>
								{dataValue}
							</ActiveComponent>
						) : (
							<InActiveComponent
								eachData={eachData}
								jsonKey={headCell.id}
							/>
						)
					) : headCell.type === "bool" ? (
						dataValue === 1 ? (
							headCell.correctIcon({
								children: <CheckCircleOutlineIcon className={classes.buttons} />,
							})
						) : null
					) : headCell.type === "date" ? (
						formatDateTime(dataValue)
					) : (dataValue)
				}
			</TableCell>
		);
	};

	const ActionsByPermission = (eachData) => {
		return Object.keys(crud).filter(each => crud[each] > 0).map((each, index) => {
			if (!permissionIcons[each]) {
				return undefined
			}
			return (
				<Tooltip
					key={index}
					placement="bottom"
					title={(
						permissionIcons[each] && permissionIcons[each].title
							? permissionIcons[each].title : undefined
					)}
				>
					<IconButton
						onClick={crudActions && crudActions[each] && crudActions[each].callback(eachData)}
						disabled={!(crud[each] > 0)}
						className={classes.buttons}
					>
						{
							permissionIcons[each]
							&& permissionIcons[each].Icon
							&& permissionIcons[each].Icon()
						}
					</IconButton>
				</Tooltip>
			);
		});
	}


	const Row = (eachData, index) => (
		<TableRow key={index} ascent="background">
			{!hideSelect ? (
				<TableCell>
					<Checkbox
						onChange={(event) => handleCheck(event, eachData, index)}
						value={isSelected(eachData)}

						// inputProps={{ "aria-labelledby": labelId }}
						color="primary"
						size="small"
					/>
				</TableCell>
			) : null}
			{Object.keys(headCells).map(Cell(eachData))}
			{!hideActionCol ? (
				CustomAction ? (
					<TableCell color={"white"} className={classes.customAction}>
						<CustomAction eachData={eachData} />
						{
							!hideCrudButtons && (
								ActionsByPermission(eachData)
							)
						}
					</TableCell>
				) : (
					<TableCell color={"white"} className={classes.action}>
						{ActionsByPermission(eachData)}
					</TableCell>
				)
			) : (
				null
			)}
		</TableRow>
	);

	const setCrudActionsByNames = () => {
		let object = {};

		Object.keys(crud).map((each, index) => {
			const { ...clonedObject } = object;
			object = {
				...clonedObject,
				[each]: {
					callback: (eachData) => () => {
						// Comes from parent
						// Use switch case based on canRead, canUpdate, canPublish etc
						onClickAction(eachData, each);
					}
				}
			}
		});

		setCrudActions({ ...object })
	}

	React.useEffect(() => {
		setCrudActionsByNames();
	}, [JSON.stringify(crud)])

	if (tableData.length < page * rowsPerPage) {
		return tableData.map(Row)
	}

	return tableData
		.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
		.map(Row);
};

TableData.propTypes = {
	ascent: validAscents,
	page: PropTypes.number,
	rowsPerPage: PropTypes.number,
};

export default TableData;
